import {lib_fr_CA} from '@docupet/component-library';
import fr_CA from '@/translations/fr-CA';

export default {
    ...lib_fr_CA,
    ...fr_CA,
};
